import linkify from 'linkify-it';

// @ts-expect-error - TS7034 - Variable 'instance' implicitly has type 'any' in some locations where its type cannot be determined.
let instance;
// @ts-expect-error - TS7005 - Variable 'instance' implicitly has an 'any' type.
export default (): any => instance || (instance = linkify());
